import { useEffect, useState } from "react"
import { Search, Plus, Eye, ShoppingCart } from "lucide-react"
import { products } from "../../data/mock"
import AddPhoneModal from "./AddPhoneModal"
import PhoneDetailsModal from "./PhoneDetailsModal"
import SellPhoneModal from "./SellPhoneModal"
import { useDispatch, useSelector } from "react-redux"
import { phonesData } from "../../store/actions"
import { useSearchParams } from "react-router-dom"

export default function Phones() {
    const userdata = useSelector((state: any) => state.UserReducer.userdata);
    const suppliersdata = useSelector((state: any) => state.UserReducer.suppliersdata || [])
    const modelsdata = useSelector((state: any) => state.UserReducer.modelsdata || [])
    const phonesdata = useSelector((state: any) => state.UserReducer.phonesdata || [])

    const [query, setQuery] = useState("")
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [phoneList, setPhoneList] = useState<any>(products)
    const [selectedPhone, setSelectedPhone] = useState<any | null>(null)
    const [phoneToSell, setPhoneToSell] = useState<any | null>(null)
    const [updateUI, setUpdateUI] = useState(Math.floor(Math.random() * 100))
    const [searchParams, setSearchParams] = useSearchParams()
    const modelFromUrl = searchParams.get("model")

    const { store } = userdata;
    const phones = phonesdata.data;
    const pagination = phonesdata.pagination;

    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const limit = 6;
    const modelId = modelFromUrl

    useEffect(() => {
        loadPhones()
    }, [updateUI])

    const loadPhones = async () => {
        // const res = await getSuppliers()
        // setSuppliers(res.data)
        // dispatch(phonesData(store?._id))
        dispatch(phonesData(store?._id, page, limit))
    }

    const filtered = phones && phones?.filter((p: any) => {
        const matchSearch =
            p.modelId?.name?.toLowerCase().includes(query.toLowerCase()) ||
            p.imei.includes(query)

        const matchModel =
            !modelFromUrl || p.modelId?._id === modelFromUrl

        return matchSearch && matchModel
    })


    const existingImeis = phones && phones?.map((p: any) => p.imei)

    return (
        <>
            <div className="space-y-6">

                {/* Header */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-800">
                            Téléphones
                        </h1>
                        <p className="text-sm text-gray-500">
                            Gestion du stock par IMEI
                        </p>
                    </div>

                    <button
                        onClick={() => setIsModalOpen(true)}
                        className="
    inline-flex items-center justify-center gap-2
    bg-blue-600 hover:bg-blue-700
    text-white px-4 py-2 rounded-xl
    transition
    w-full sm:w-auto
  "
                    >

                        <Plus size={18} />
                        Ajouter téléphone
                    </button>
                </div>

                {/* Search + Active filter */}
                <div className="flex flex-col sm:flex-row sm:items-center gap-3">

                    {/* Search */}
                    <div className="relative w-full sm:max-w-md flex-1">
                        <Search
                            size={18}
                            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                        />
                        <input
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder="Rechercher par IMEI ou modèle..."
                            className="
                pl-10 pr-4 py-2 w-full
                border rounded-xl
                focus:ring-2 focus:ring-blue-500
                outline-none
            "
                        />
                    </div>

                    {/* Model filter badge */}
                    {modelFromUrl && (
                        <div className="
            flex items-center justify-between sm:justify-start
            gap-3
            bg-blue-50 border border-blue-200
            rounded-xl px-4 py-2
            w-full sm:w-auto
        ">
                            <span className="text-sm text-blue-700 font-medium whitespace-nowrap">
                                Filtré par modèle
                            </span>

                            <button
                                onClick={() => setSearchParams({})}
                                className="
                    text-sm px-3 py-1
                    rounded-lg
                    bg-blue-600 text-white
                    hover:bg-blue-700 transition
                    whitespace-nowrap
                "
                            >
                                Afficher tous
                            </button>
                        </div>
                    )}

                </div>


                {/* Table */}
                <div className="hidden md:block bg-white rounded-2xl shadow-sm border overflow-hidden">
                    <table className="w-full text-sm">
                        <thead className="bg-gray-50">
                            <tr className="text-left text-gray-500">
                                <th className="px-6 py-3">Modèle</th>
                                <th className="px-6 py-3">IMEI</th>
                                <th className="px-6 py-3">Prix achat</th>
                                <th className="px-6 py-3">Prix vente</th>
                                <th className="px-6 py-3">Statut</th>
                                <th className="px-6 py-3 text-right">Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filtered && filtered?.map((p: any) => (
                                <tr
                                    key={p?._id}
                                    className="border-t hover:bg-gray-50 transition"
                                >
                                    <td className="px-6 py-4 font-medium text-gray-800">
                                        {p.modelId.name}
                                    </td>

                                    <td className="px-6 py-4 text-gray-600">
                                        {p.imei}
                                    </td>

                                    <td className="px-6 py-4 text-gray-600">
                                        {p.buyPrice.toLocaleString()} FCFA
                                    </td>

                                    <td className="px-6 py-4 text-gray-600">
                                        {p.status === "SOLD" && p.sellPrice
                                            ? `${p.sellPrice.toLocaleString()} FCFA`
                                            : "-"
                                        }
                                    </td>

                                    <td className="px-6 py-4">
                                        {p.status === "IN_STOCK" ? (
                                            <span className="px-3 py-1 rounded-full text-xs bg-green-100 text-green-700">
                                                En stock
                                            </span>
                                        ) : (
                                            <span className="px-3 py-1 rounded-full text-xs bg-red-100 text-red-700">
                                                Vendu
                                            </span>
                                        )}
                                    </td>

                                    <td className="px-6 py-4 text-right">
                                        <div className="flex justify-end gap-2">
                                            <button
                                                onClick={() => setSelectedPhone(p)}
                                                className="p-2 rounded-lg hover:bg-gray-100 transition"
                                                title="Voir"
                                            >
                                                <Eye size={16} />
                                            </button>

                                            {p.status === "IN_STOCK" && (
                                                <button
                                                    onClick={() => setPhoneToSell(p)}
                                                    className="p-2 rounded-lg hover:bg-gray-100 transition"
                                                    title="Vendre"
                                                >
                                                    <ShoppingCart size={16} />
                                                </button>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}

                            {filtered?.length === 0 && (
                                <tr>
                                    <td
                                        colSpan={5}
                                        className="px-6 py-10 text-center text-gray-500"
                                    >
                                        Aucun téléphone trouvé
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                </div>


                {/* Mobile Cards */}
                <div className="space-y-4 md:hidden">
                    {filtered && filtered?.map((p: any) => (
                        <div
                            key={p?.id}
                            className="bg-white rounded-2xl shadow-sm border p-4 space-y-3"
                        >
                            <div className="flex justify-between items-start">
                                <div>
                                    <p className="font-semibold text-gray-800">
                                        {p.name}
                                    </p>
                                    <p className="text-xs text-gray-500 break-all">
                                        IMEI : {p.identifier}
                                    </p>
                                </div>

                                {p.status === "IN_STOCK" ? (
                                    <span className="px-3 py-1 rounded-full text-xs bg-green-100 text-green-700">
                                        En stock
                                    </span>
                                ) : (
                                    <span className="px-3 py-1 rounded-full text-xs bg-red-100 text-red-700">
                                        Vendu
                                    </span>
                                )}
                            </div>

                            <div className="flex justify-between items-center text-sm">
                                <span className="text-gray-500">Prix achat</span>
                                <span className="font-medium">
                                    {p.buyPrice.toLocaleString()} FCFA
                                </span>
                            </div>

                            {p.status === "SOLD" && p.sellPrice && (
                                <div className="flex justify-between items-center text-sm">
                                    <span className="text-gray-500">Prix vente</span>
                                    <span className="font-semibold text-green-600">
                                        {p.sellPrice.toLocaleString()} FCFA
                                    </span>
                                </div>
                            )}

                            <div className="flex justify-end gap-2 pt-2">
                                <button
                                    className="p-2 rounded-lg border hover:bg-gray-50"
                                    title="Voir"
                                >
                                    <Eye size={16} />
                                </button>

                                {p.status === "IN_STOCK" && (
                                    <button
                                        className="p-2 rounded-lg border hover:bg-gray-50"
                                        title="Vendre"
                                    >
                                        <ShoppingCart size={16} />
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}

                    {filtered?.length === 0 && (
                        <div className="text-center text-gray-500 py-10">
                            Aucun téléphone trouvé
                        </div>
                    )}
                </div>


                {/* Pagination */}
                {pagination?.totalPages > 1 && (
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pt-4">

                        <p className="text-sm text-gray-500">
                            Page {pagination.page} sur {pagination.totalPages}
                        </p>

                        <div className="flex gap-2">
                            <button
                                disabled={page === 1}
                                onClick={() => setPage(p => p - 1)}
                                className="
                                    px-4 py-2 rounded-xl border
                                    disabled:opacity-50
                                    hover:bg-gray-100 transition
                                "
                            >
                                Précédent
                            </button>

                            <button
                                disabled={page === pagination.totalPages}
                                onClick={() => setPage(p => p + 1)}
                                className="
                                    px-4 py-2 rounded-xl
                                    bg-blue-600 text-white
                                    disabled:opacity-50
                                    hover:bg-blue-700 transition
                                "
                            >
                                Suivant
                            </button>
                        </div>
                    </div>
                )}
            </div>


            <AddPhoneModal
                currentStore={store}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                existingImeis={existingImeis}
                suppliers={suppliersdata}
                models={modelsdata.data}
                onAdd={(newPhone) =>
                    setPhoneList((prev: any) => [newPhone, ...prev])
                }
            />

            <PhoneDetailsModal
                phone={selectedPhone}
                onClose={() => setSelectedPhone(null)}
            />

            <SellPhoneModal
                currentStore={store}
                phone={phoneToSell}
                onClose={() => setPhoneToSell(null)}
                onSell={(updatedPhone) =>
                    setPhoneList((prev: any) =>
                        prev.map((p: any) =>
                            p._id === updatedPhone._id ? updatedPhone : p
                        )
                    )
                }
            />

        </>
    )
}
